export type JobRunStatus =
    | 'PENDING'
    | 'GENERATING_CODE'
    | 'SUBMITTING_QUERY'
    | 'QUERY_SUBMITTED'
    | 'QUERY_RUNNING'
    | 'COMPLETED'
    | 'CODE_RETRIEVED'
    | 'FAILED'
    | 'SUBMISSION_FAILED'
    | 'QUERY_FAILED'
    | 'MONITORING_FAILED'
    | 'RETRIEVAL_FAILED'
    | 'RETRYING'
    | 'FAILED_MAX_RETRIES'
    | 'SUCCEEDED'
    | 'PERSISTING'
    | 'VERIFYING'
    | 'PUBLISHING'
    | 'PERSISTENCE_FAILED';

export const FAILURE_STATUSES: JobRunStatus[] = [
  'FAILED',
  'SUBMISSION_FAILED',
  'QUERY_FAILED',
  'MONITORING_FAILED',
  'FAILED_MAX_RETRIES',
  'RETRIEVAL_FAILED',
  'PERSISTENCE_FAILED',
];

export const IN_PROGRESS_STATUSES: JobRunStatus[] = [
  'PENDING',
  'GENERATING_CODE',
  'SUBMITTING_QUERY',
  'QUERY_SUBMITTED',
  'QUERY_RUNNING',
  'RETRYING',
  'PERSISTING',
  'VERIFYING',
  'PUBLISHING',
];

export const isFailureStatus = (status: JobRunStatus): boolean => {
  return FAILURE_STATUSES.includes(status);
};

export const isInProgress = (status: JobRunStatus): boolean => {
  return IN_PROGRESS_STATUSES.includes(status);
};

export type RunType = 'NORMAL' | 'ADHOC' | 'SCHEDULED' | 'PUBLISH';
